import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ComponentsModule } from 'components/components.module';
import { TestUiToastsPage } from './test-ui-toasts';

@NgModule({
  declarations: [
    TestUiToastsPage
  ],
  imports: [
    CommonModule,
    ComponentsModule
  ]
})
export class TestUiToastsPageModule {}